<template>

  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >


<v-app-bar
      app
      color="grey lighten-4"
    >
          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>

    
         </v-app-bar>
<v-system-bar
      window
      color="#233067"
      dark
      shrink-on-scroll
      src="https://picsum.photos/1920/1080?random"
    >
      <v-icon color="white">mdi-chart-bar</v-icon>
      <span :style="{color: 'white'}">Data Visualization & Early Intervention</span>
      <v-spacer></v-spacer>

    </v-system-bar>

     <v-divider></v-divider>
     

  <v-card
    class="mx-auto"
    max-width="500"
  >
  <v-card-text>
 <div class="text--primary">
        Please sign into ConciergePad
      </div>
  </v-card-text>
    <v-card-text>
      <v-text-field
      v-model="emailValue"
      label="Username"
      solo
      outlined
    ></v-text-field>

    </v-card-text>

    <v-card-text>

      <v-text-field
      v-model="password"
      :type="'password'"
      label="Password"
      solo
      outlined
    ></v-text-field>

    <v-alert type="error" v-model="passwordAlert">
      {{message}}
    </v-alert>

    </v-card-text>
    <v-card-actions>
      <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click="buttonPressed"
    >
      Login
    </v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="lostPassword"
      >
        Lost Password
      </v-btn>
    </v-card-actions>
  </v-card>
  


    



    


    




    




 
  </v-form>

  
</template>


<script>

  import axios from 'axios';
  import store from '../store';

  export default {
    data: () => ({
      passwordAlert: false,
      message: '',
      alert: false,
      loaded: false,
      results: {},
      pId: '',
      jwsToken: '',
      username: '',
      password: '',
      reTypePassword: '',
      valid: true,
      validCode: false,
      invalidCode: false,
      items: [],
      name: '',
      accessToken: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
      
      console.log(this.$route.query.id);

      this.pId = this.$route.query.id;
      
      this.emailValue = this.$route.query.user;
      this.password = this.$route.query.pass;

   
  },

    methods: {

    lostPassword() {

      console.log("GO TO LOST PASSWORD");


      //this.$router.push('Lost'); 

      //window.location.href = "https://www.conciergepadedu.com/lost_password.aspx"

      window.open("https://www.conciergepadedu.com/lost_password.aspx", "_blank");    

    },
      
    buttonPressed() {

        this.loaded = true

        //if (this.emailValue != "" && this.password != "") {
        if (this.emailValue && this.password) {

  console.log("Here in username and password");

  axios
    .post(
      "https://api.conciergepadedu.com/api/auth/cptoken",
      {
         USERNAME: this.emailValue,
         PASSWORD: this.password 
      }
    )
    .then(response => {

      if (response.data.error) {

        console.log("Error on token");
        console.log(response.data.error);
        this.loaded = false;

        this.$alert("Login not successful","Login","error");


      } else {
      //this.resp = response;

      this.results = response.data

      console.log(response.data);

      console.log("Token");

        this.accessToken = JSON.stringify(response.data);


        this.jwsToken = response.data;

        console.log("data")
        console.log(this.jwsToken)
  
        this.bearerConfig = {
            headers: {
            Authorization: "Bearer " + response.data
            }
        }


      axios.get('https://api.conciergepadedu.com/api/Profiles/' +  this.emailValue,this.bearerConfig).then(response => {

      if (response.data.error) {

          console.log("ERROR");
          console.log('error', response.data.error);
          this.loaded = false

          //this.emailValue = ''
          //this.password = ''

          this.$alert("Login not successful","Login","error");

        

      } else {

        this.postStatus = true;

        console.log('success', response.data)

        this.results = response.data
  
         const payload = {'token': this.jwsToken, 'user': this.results.username,'comp':this.results.companY_NAME,'email':this.results.username,'pId':this.results.id,'password':this.results.password}
         store.dispatch('addAuth',payload);

         localStorage.setItem('jwsToken', JSON.stringify(this.jwsToken));


        this.loaded = false


        this.$router.push('VisualDetail') 

        }

        }).catch(error => {

            this.loaded = false
            console.log("CATCH ERROR");
            console.log(error.response);

            this.emailValue = ''
            this.password = ''

            this.$alert("Login not successful","Login","error");


        });


      }


      }).catch(error => {


      console.log("Catch Error (1)");

      console.log(error);
      console.log(error.message);

      this.$alert("Login not successful","Login","error");

     this.loaded = false;


    })

  } else {


    console.log("No Username or Password");
    this.loaded = false;

   
      }

    

 

} ,
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>